import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Services } from "@/components/landing/Services";
import { Gallery } from "@/components/landing/Gallery";
import { About } from "@/components/landing/About";
import { BookingForm } from "@/components/landing/BookingForm";
import { Footer } from "@/components/landing/Footer";

function App() {
  return (
    <div id="top" className="min-h-screen bg-brand-ground font-body text-brand-ink antialiased">
      <Header />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <About />
        <BookingForm />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
